var _defs, _rect, _polygon, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntelligentResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_9);}.cls-2{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_9-2);}.cls-3{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_9-3);}.cls-4{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_9-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_9",
    x1: 31.37,
    y1: 37.39,
    x2: 31.37,
    y2: 33.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#e88143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fea74a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_9-2",
    x1: 39,
    y1: 27.06,
    x2: 39,
    y2: 15.85,
    xlinkHref: "#\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_9-3",
    x1: 31.37,
    y1: 45.54,
    x2: 31.37,
    y2: 41.46,
    xlinkHref: "#\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_9-4",
    x1: 32.01,
    y1: 62.59,
    x2: 31.99,
    y2: -1.43,
    xlinkHref: "#\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_9"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "s2_\u5BA1\u65B9\u7ED3\u679C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.22,
    y: 33.41,
    width: 16.29,
    height: 4.07
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.4 27.3 44.6 27.3 33.4 16.1 33.4 27.3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 23.22,
    y: 41.55,
    width: 16.29,
    height: 4.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M60,0H4A4,4,0,0,0,0,4V60a4,4,0,0,0,4,4H60a4,4,0,0,0,4-4V4A4,4,0,0,0,60,0ZM47.66,49.7a4.09,4.09,0,0,1-4.08,4.07H19.13a4.06,4.06,0,0,1-4-4.07l0-32.58a4.06,4.06,0,0,1,4-4.07H35.44L47.66,25.27Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentResult);
export default __webpack_public_path__ + "static/media/IntelligentResult.35e403e8.svg";
export { ForwardRef as ReactComponent };